import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import OfferPopup from "../OfferPopup/OfferPopup";
import { CartContext } from "../../contexts/CartContext";

const OfferController = () => {
    const location = useLocation();
    const { cartItems, getTotal } = useContext(CartContext);

    const [showOffer, setShowOffer] = useState(false);

    const FIVE_MIN = 5 * 60 * 1000;
    const INITIAL_DELAY = 5000;

    // ❌ Skip unwanted pages
    const skipRoutes = ["/login", "/verify-otp"];

    // ✅ Check frequency
    const canShowPopup = () => {
        const last = localStorage.getItem("offerLastShown");
        const count = sessionStorage.getItem("offerCount") || 0;

        const now = Date.now();

        if (count >= 3) return false; // max 3 per session
        if (!last || now - last > FIVE_MIN) return true;

        return false;
    };

    const markShown = () => {
        localStorage.setItem("offerLastShown", Date.now());
        const count = parseInt(sessionStorage.getItem("offerCount") || "0");
        sessionStorage.setItem("offerCount", count + 1);
    };

    // ✅ Main trigger (route change)
    useEffect(() => {
        if (skipRoutes.includes(location.pathname)) return;

        const timer = setTimeout(() => {
            if (canShowPopup()) {
                setShowOffer(true);
                markShown();
            }
        }, INITIAL_DELAY);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    // ✅ Exit intent (desktop)
    // useEffect(() => {
    //     const handleExit = (e) => {
    //         if (e.clientY < 10 && canShowPopup()) {
    //             setShowOffer(true);
    //             markShown();
    //         }
    //     };

    //     document.addEventListener("mouseout", handleExit);
    //     return () => document.removeEventListener("mouseout", handleExit);
    // }, []);

    // ✅ Scroll trigger
    useEffect(() => {
        const handleScroll = () => {
            const scrolled =
                (window.scrollY / (document.body.scrollHeight - window.innerHeight)) *
                100;

            if (scrolled > 60 && canShowPopup()) {
                setShowOffer(true);
                markShown();
                window.removeEventListener("scroll", handleScroll);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // ✅ Cart-based trigger
    useEffect(() => {
        const total = getTotal?.() || 0;

        if (total > 3000 && canShowPopup()) {
            setShowOffer(true);
            markShown();
        }
    }, [cartItems]);

    return (
        <>
            {showOffer && (
                <OfferPopup
                    onClose={() => setShowOffer(false)}
                    cartValue={getTotal?.()}
                />
            )}
        </>
    );
};

export default OfferController;